/** Draft Privacy Policy (FR) — validate with counsel before relying on as final legal text. */
export const privacyFr = {
  title: 'Politique de confidentialité',
  lastUpdatedLabel: 'Dernière mise à jour',
  lastUpdated: '27 juillet 2026',
  sections: [
    {
      heading: '1. Responsable du traitement',
      paragraphs: [
        "La présente Politique de confidentialité décrit comment Rentalyzer / DMII (« nous ») collecte, utilise, communique et protège les renseignements personnels dans le cadre de la plateforme Rentalyzer (le « Service »).",
        'Pour toute demande relative à la vie privée : mmarceau@dmii.ca.',
      ],
    },
    {
      heading: '2. Portée',
      paragraphs: [
        "Cette Politique s'applique à l'utilisation du Service (site web et applications associées), y compris la création de compte, l'analyse d'immeubles, le partage de deals et les communications liées au Service. Elle est conçue pour s'aligner sur la Loi 25 (Québec) et la LPRPDE (Canada), selon le contexte.",
      ],
    },
    {
      heading: '3. Renseignements que nous collectons',
      paragraphs: [
        'Selon votre utilisation, nous pouvons collecter :',
      ],
      list: [
        "Identité et compte : adresse courriel, nom d'affichage, mot de passe (géré par le fournisseur d'authentification), photo de profil le cas échéant, langue, type de compte.",
        'Coordonnées et profil : téléphone, adresse, nom d\'entreprise (notamment si un module professionnel est demandé).',
        "Données d'analyse immobilière : adresses et caractéristiques d'immeubles, prix, loyers, dépenses, paramètres de financement, scénarios, images et descriptions marketing que vous saisissez.",
        'Documents et fichiers : documents de projet, contrats, spécimens ou autres fichiers que vous téléversez dans le Service.',
        'Partages et interactions : liens de partage, destinataires, messages, intérêts, invitations, campagnes (le cas échéant).',
        "Données techniques : journaux d'accès, type d'appareil/navigateur, adresses IP approximatives, jetons de session et données de diagnostic nécessaires au fonctionnement et à la sécurité (via notamment Firebase / Google).",
        "Communications : courriels transactionnels (réinitialisation de mot de passe, invitations, notifications) et messages de soutien.",
      ],
    },
    {
      heading: '4. Finalités',
      paragraphs: [
        'Nous utilisons les renseignements personnels pour :',
      ],
      list: [
        'fournir, maintenir et sécuriser le Service ;',
        'créer et gérer votre compte, authentifier les utilisateurs et traiter les demandes de soutien ;',
        'permettre les analyses, rapports, partages et collaborations que vous initiez ;',
        "envoyer des communications transactionnelles liées au Service ;",
        'prévenir la fraude, les abus et les incidents de sécurité ;',
        "respecter nos obligations légales ;",
        "améliorer le Service et produire des statistiques, indicateurs et données de marché à partir de données anonymisées ou agrégées (voir section 5).",
      ],
    },
    {
      heading: '5. Données de marché, anonymisation et agrégation',
      paragraphs: [
        "L'un des objectifs de Rentalyzer est de mieux comprendre le marché immobilier locatif. À cette fin, nous pouvons utiliser les données d'analyses et de deals que vous saisissez (par exemple prix, loyers, dépenses, taux, typologie d'immeuble, localisation à une granularité appropriée) pour générer des statistiques, des indicateurs de marché et des modèles après anonymisation et/ou agrégation.",
        "Nous nous efforçons de traiter ces usages de manière à ce que les ensembles publiés ou utilisés en interne ne permettent pas, dans des conditions raisonnables, de réidentifier une personne ou un immeuble précis. Les données brutes nominatives de votre compte ne sont pas vendues comme liste marketing nominative.",
        "En acceptant cette Politique lors de l'inscription, vous consentez à cet usage secondaire anonymisé ou agrégé, sous réserve du droit applicable et de vos droits décrits ci-dessous.",
      ],
    },
    {
      heading: '6. Fondements et consentement',
      paragraphs: [
        "Nous traitons les renseignements personnels lorsque cela est nécessaire à l'exécution du Service que vous demandez, pour nos intérêts légitimes liés à la sécurité et à l'amélioration du Service (dans les limites du droit applicable), pour respecter la loi, ou avec votre consentement lorsque requis (par exemple à l'inscription).",
        "Vous pouvez retirer certains consentements lorsque la loi le permet ; le retrait peut limiter l'usage de fonctionnalités. Le retrait n'affecte pas la licéité des traitements effectués avant le retrait.",
      ],
    },
    {
      heading: '7. Communication à des tiers et sous-traitants',
      paragraphs: [
        "Nous pouvons faire appel à des fournisseurs pour héberger et faire fonctionner le Service, notamment :",
      ],
      list: [
        'Google Firebase (authentification, base de données, stockage, fonctions cloud) ;',
        'Google / Vertex AI (lorsque des fonctions d\'assistance ou d\'extraction documentaire sont utilisées) ;',
        'Resend ou services d\'envoi de courriel transactionnel ;',
        "Google Maps / Places (saisie d'adresses), le cas échéant ;",
        "hébergeurs web (par ex. serveur cPanel) pour la distribution de l'interface.",
      ],
      paragraphsAfterList: [
        "Ces fournisseurs traitent des données pour notre compte selon leurs conditions et mesures de sécurité. Nous pouvons aussi communiquer des renseignements si la loi l'exige, pour protéger nos droits, ou avec votre instruction (par ex. partage d'un deal avec un destinataire que vous choisissez).",
      ],
    },
    {
      heading: '8. Transferts hors Québec / Canada',
      paragraphs: [
        "Certains fournisseurs (notamment Google / Firebase) peuvent traiter des données aux États-Unis ou dans d'autres juridictions. Lorsque de tels transferts ont lieu, nous nous appuyons sur des mécanismes contractuels et organisationnels appropriés dans la mesure du possible. En utilisant le Service, vous reconnaissez que vos données peuvent être traitées hors du Québec.",
      ],
    },
    {
      heading: '9. Conservation',
      paragraphs: [
        "Nous conservons les renseignements personnels aussi longtemps que nécessaire pour fournir le Service, respecter nos obligations légales, résoudre les litiges et faire appliquer nos ententes. Les données anonymisées ou agrégées peuvent être conservées plus longtemps, car elles ne constituent plus des renseignements personnels identifiables.",
        "Lorsque vous demandez la suppression de votre compte, nous supprimerons ou anonymiserons les données associées selon nos procédures techniques, sous réserve des copies de sauvegarde et des obligations de conservation légales.",
      ],
    },
    {
      heading: '10. Sécurité',
      paragraphs: [
        "Nous mettons en œuvre des mesures techniques et organisationnelles raisonnables (contrôle d'accès, chiffrement en transit via HTTPS, règles d'accès aux bases de données, etc.). Aucun système n'est totalement sécurisé ; vous devez aussi protéger vos identifiants et appareils.",
      ],
    },
    {
      heading: '11. Cookies et stockage local',
      paragraphs: [
        "Le Service utilise des mécanismes de stockage du navigateur (p. ex. localStorage / sessionStorage) et des cookies ou technologies similaires nécessaires à l'authentification, à la session, à la langue et au bon fonctionnement de l'application. Ces technologies ne sont pas utilisées ici pour de la publicité comportementale tierce.",
        "Vous pouvez configurer votre navigateur pour limiter certains stockages ; cela peut affecter le fonctionnement du Service.",
      ],
    },
    {
      heading: '12. Vos droits',
      paragraphs: [
        "Sous réserve du droit applicable (notamment Loi 25 et LPRPDE), vous pouvez demander l'accès à vos renseignements personnels, leur rectification, ou exercer d'autres droits (retrait de consentement, plainte, etc.). Pour ce faire, contactez mmarceau@dmii.ca. Nous pourrons vérifier votre identité avant de répondre.",
        "Vous pouvez aussi déposer une plainte auprès de la Commission d'accès à l'information du Québec ou du Commissariat à la protection de la vie privée du Canada, selon le cas.",
      ],
    },
    {
      heading: '13. Enfants',
      paragraphs: [
        "Le Service n'est pas destiné aux personnes de moins de 18 ans. Nous ne collectons pas sciemment de renseignements personnels auprès d'enfants.",
      ],
    },
    {
      heading: '14. Modifications',
      paragraphs: [
        "Nous pouvons mettre à jour cette Politique. La date de mise à jour et la version applicable seront indiquées sur cette page. En cas de changement important, nous pourrons aussi vous en informer par le Service ou par courriel.",
      ],
    },
    {
      heading: '15. Contact',
      paragraphs: [
        'Rentalyzer / DMII — mmarceau@dmii.ca — https://rentalyzer.ca',
      ],
    },
  ],
};
